export default __webpack_public_path__ + "static/media/pixIconBlue.46dc5034.svg";